<template>
	<popper :trigger="trigger" :disabled="disabled" :append-to-body="appendToBody" :options="{ placement: placement }">
		<div class="ui-popover" :class="[{ 'has-footer': hasFooter }, { 'has-header': hasHeader }]">
			<div class="ui-popover-header" v-if="hasHeader">
				{{ header }}
				<slot name="header"></slot>
			</div>

			<div class="ui-popover-content" v-if="hasContent" :style="{'padding': paddingContent}">
				{{ content }}
				<slot name="content"></slot>
			</div>

			<div class="ui-popover-footer" v-if="hasFooter">
				{{ footer }}
				<slot name="footer"></slot>
			</div>

			<div class="ui-popover-arrow" v-if="arrowPopover"></div>
		</div>

		<button class="ui-popover-reference" slot="reference">
			<slot name="target"></slot>
		</button>
	</popper>
</template>

<script>
	import Popper from 'vue-popperjs'

	export default {
		name: 'ui-popover',

		components: {
			popper: Popper,
		},

		props: {
			content: {
				type: String,
				default: '',
			},

			header: {
				type: String,
				default: '',
			},

			footer: {
				type: String,
				default: '',
			},

			placement: {
				type: String,
				default: 'top',
			},

			trigger: {
				type: String,
				default: 'click',
			},

			width: {
				type: Number,
			},

			appendToBody: {
				type: Boolean,
				default: true,
			},

			disabled: {
				type: Boolean,
				default: false,
			},
			paddingContent : {
				type: String,
				default: '20px',
			},
			arrowPopover: {
				type: Boolean,
				default: true
			}
		},

		data() {
			return {}
		},

		computed: {
			hasContent() {
				return this.$slots.content || this.content ? true : false
			},

			hasHeader() {
				return this.$slots.header || this.header ? true : false
			},

			hasFooter() {
				return this.$slots.footer || this.footer ? true : false
			},
		},

		methods: {},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>